import Reveal from "@stimulus-components/reveal"

export default class extends Reveal {
  static targets = [...Reveal.targets, "indicator"]
  static classes = [...Reveal.classes, "indicatorRevealed"]

  targetsAreHidden() {
    return this.itemTargets.reduce((result, item) => {
      return result || item.classList.contains(this.class)
    }, false)
  }

  toggle() {
    super.toggle()

    if (this.hasIndicatorRevealedClass) {
      const hidden = this.targetsAreHidden()

      this.indicatorTargets.forEach((indicator) => {
        if (hidden) {
          indicator.classList.remove(this.indicatorRevealedClass)
        } else {
          indicator.classList.add(this.indicatorRevealedClass)
        }
      })
    }
  }

  show() {
    super.show()

    if (this.hasIndicatorRevealedClass) {
      this.indicatorTargets.forEach((indicator) => {
        indicator.classList.add(this.indicatorRevealedClass)
      })
    }
  }

  hide() {
    super.hide()

    if (this.hasIndicatorRevealedClass) {
      this.indicatorTargets.forEach((indicator) => {
        indicator.classList.remove(this.indicatorRevealedClass)
      })
    }
  }
}